export enum PermissionEnum {
  MENU = "menu",
  MENU_CHILD = "menu-child",
  ROUTE = "route",
  ACTION_BUTTON = "action-button",
  WIDGET = "widget",
  CONFIGURATION = "configuration"
}

export enum AccessType {
  READ = "R",
  WRITE = "W"
}

export enum ConfigTypeEnum {
  IJB = "IJB",
  GJB = "GJB",
  PRB = "PRB",
  SRB = "SRB"
}
